import { createReducer, on } from "@ngrx/store";
import { IProfessionalTransfersReport } from "src/app/shared/interfaces/professional-transfers-report/iprofessionaltransfersreport";
import { ProfessionalTransfersReportActions } from "./professional-transfers-report.actions";

export interface IProfessionalTransfersReportState {
    professional_transfers_report: IProfessionalTransfersReport
}

const initialState: IProfessionalTransfersReportState = {
    professional_transfers_report: {
        faturamento_total: '80.000',
        receita_profissional: '50.000',
        receita_empresa: '30.000',
        valor_a_pagar_empresa: '500',
        chart_data: [
            {
                legend: 'Total Bruto',
                data: [4000, 1900, 2500, 1000, 1500, 3100, 3300, 3200, 4000, 3600, 4100, 3300],
                gradientColors: ['rgba(0, 160, 0, 1)', 'rgba(255, 255, 255, 0)']
            },
            {
                legend: 'Total Profissional',
                data: [3700, 2900, 2900, 3000, 3200, 2600, 3100, 2800, 1600, 2900, 3100, 2900],
                gradientColors: ['rgba(255, 131, 33, 1)', 'rgba(255, 255, 255, 0)']
            },
            {
                legend: 'Total Empresa',
                data: [4500, 3700, 4000, 3400, 4800, 3700, 3990, 2100, 4800, 4800, 4800, 3800],
                gradientColors: ['rgba(0, 74, 160, 1)', 'rgba(255, 255, 255, 0)']
            },
            

        ],
        chart_label: ['01/23', '02/23', '03/23', '04/23', '05/23', '06/23', '07/23', '08/23', '09/23', '10/23', '11/23', '12/23'],
        listagem_profissionais: [
            {
                posicao_ranking: 1,
                nome: 'Alexandre Lucio',
                atendimentos: '30',
                split: true,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '30',
                comparativo_receita_mes_ant_porcento: '+30',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ]
            },
            {
                posicao_ranking: 2,
                nome: 'Antônio Carlos',
                atendimentos: '25',
                split: false,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '10',
                comparativo_receita_mes_ant_porcento: '+05',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
            {
                posicao_ranking: 3,
                nome: 'Augusto Santos',
                atendimentos: '20',
                split: true,
                valor_total: '4.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '500',
                comparativo_receita_mes_ant_porcento: '-10',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
            {
                posicao_ranking: 4,
                nome: 'Antônio Carlos',
                atendimentos: '25',
                split: true,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '10',
                comparativo_receita_mes_ant_porcento: '+05',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
            {
                posicao_ranking: 5,
                nome: 'Alexandre Lucio',
                atendimentos: '30',
                split: true,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '30',
                comparativo_receita_mes_ant_porcento: '+30',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ]
            },
            {
                posicao_ranking: 6,
                nome: 'Antônio Carlos',
                atendimentos: '25',
                split: false,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '10',
                comparativo_receita_mes_ant_porcento: '+05',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
            {
                posicao_ranking: 7,
                nome: 'Augusto Santos',
                atendimentos: '20',
                split: true,
                valor_total: '4.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '500',
                comparativo_receita_mes_ant_porcento: '-10',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
            {
                posicao_ranking: 8,
                nome: 'Antônio Carlos',
                atendimentos: '25',
                split: true,
                valor_total: '3.350',
                valor_para_profissional: '2.000',
                porcentagem_profissional: "59",
                valor_empresa: '1.500',
                porcentagem_empresa: '41',
                valor_pendente: '10',
                comparativo_receita_mes_ant_porcento: '+05',
                relatorio_atendimentos: [
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '13/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Carlos Antônio',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Retorno',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '410',
                        especialista: '410'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Gabriel Lima',
                        servico: 'Consulta de Retorno',
                        valor_total: '410',
                        centro: '310',
                        especialista: '310'
                    },
                    {
                        data: '12/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Leonardo Patrício',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '250',
                        centro: '250',
                        especialista: '250'
                    },
                    {
                        data: '14/12/2023',
                        paciente: 'Maria de Fátima',
                        servico: 'Consulta de Neuropediatria',
                        valor_total: '350',
                        centro: '350',
                        especialista: '350'
                    }
                ],
                valor_ideal_profissional_porcentagem: '60',
                valor_ideal_empresa_porcentagem: '40',
            },
        ],
        total_listagem_profissionais: {
            atendimentos: '100',
            split: '75',
            valor_total: '15.000',
            valor_para_profissional: '9.800',
            valor_para_profissional_porcentagem: '59',
            valor_para_profissional_ideal: '60',
            valor_para_empresa: '9.000',
            valor_para_empresa_porcentagem: '41',
            valor_para_empresa_ideal: '40',
            valor_pendente: '2.000',
            comparativo_receita_mes_ant: '+05'
        },
    }
}

export const professionalTransfersReportReducer = createReducer(
    initialState,
    on(
        ProfessionalTransfersReportActions.loadProfessionalTransfersReportSuccess,
        (state, { professional_transfers_report }) => ({
            ...state,
            professional_transfers_report: professional_transfers_report
        })
    )
)